import { types } from '../types'

const initialState = {
  waiting: false,
  success: false,
  error: '',
  listData: {},
  userData: {}

}

const getAllUsersReducer = (state = initialState, { type, action }) => {
  switch (type) {
    case types.GET_ALL_USERS_REQUEST: {
          return {
        ...state,
        waiting: false,
        success: false,
      }
    }
    case types.GET_ALL_USERS_ERROR: {
      return {
        ...state,
        waiting: false,
        error: action.error

      }
    }

    case types.GET_ALL_USERS_SUCCESS: {
       return {
        ...state,
        waiting: false,
        success: true,
        error: '',
        listData: action.data
      }
    }


    case types.GET_USER_INFO_REQUEST: {

      return {
        ...state,
        waiting: false,
        success: false,
      }
    }
    case types.GET_USER_INFO_ERROR: {
      return {
        ...state,
        waiting: false,
        error: action?.error

      }
    }

    case types.GET_USER_INFO_SUCCESS: {
      return {
        ...state,
        waiting: false,
        success: true,
        error: '',
        userData: action.data
      }
    }

    default:
      return state
  }
}

export default getAllUsersReducer;